
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rent-my-motorcycle",
      function () {
        return require("private-next-pages/rent-my-motorcycle/index.js");
      }
    ]);
  